import SettingsPage from './views/settings.page'

export default {
  views: {
    SettingsPage
  }
}
